
import React from 'react';
import { motion } from 'framer-motion';
const ProjectCard = ({ project, onClick }) => {
  return (
    <motion.div 
      whileHover={{ scale: 1.02 }}
      className="relative group cursor-pointer"
      onClick={() => onClick(project)}
    >
      <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-400 via-fuchsia-500 to-cyan-400 
                    rounded-lg blur opacity-20 group-hover:opacity-40 transition duration-300"></div>
      
      <div className="relative bg-black border-2 border-[#ff00ff] rounded-lg p-4 md:p-6 h-full 
                    hover:border-cyan-400 transition-colors duration-300">
        <div className="mb-3 md:mb-4 border-b border-[#ff00ff]/30 pb-2">
          <h3 className="text-lg md:text-xl font-mono text-cyan-400 group-hover:text-[#ff00ff] transition-colors">
            &gt; {project.title}
          </h3>
        </div>

        <p className="text-green-500 mb-4 font-mono text-xs md:text-sm">
          {project.description}
        </p>

        <div className="flex flex-wrap gap-1.5 md:gap-2 mt-auto">
          {project.skills.map((skill, index) => (
            <span 
              key={index} 
              className="px-1.5 md:px-2 py-0.5 md:py-1 text-xs font-mono rounded 
                       bg-black border border-cyan-400 text-cyan-400
                       group-hover:border-[#ff00ff] group-hover:text-[#ff00ff]
                       transition-colors duration-300"
            >
              {skill}
            </span>
          ))}
        </div>

        <div className="absolute top-0 left-0 w-2 h-2 border-t-2 border-l-2 border-cyan-400"></div>
        <div className="absolute top-0 right-0 w-2 h-2 border-t-2 border-r-2 border-cyan-400"></div>
        <div className="absolute bottom-0 left-0 w-2 h-2 border-b-2 border-l-2 border-cyan-400"></div>
        <div className="absolute bottom-0 right-0 w-2 h-2 border-b-2 border-r-2 border-cyan-400"></div>
      </div>
    </motion.div>
  );
};


export default ProjectCard;